<template>
  <tourism-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </tourism-form>
</template>

<script>
import TourismForm from '@/components/Tourism/Form'
import ButtonUpdate from '@/components/Tourism/ButtonUpdate'
import ButtonDelete from '@/components/Tourism/ButtonDelete'

export default {
  components: {
    TourismForm,
    ButtonUpdate,
    ButtonDelete
  },
  created: async function () {
    await this.$store.dispatch(
      'tourism/getTourism',
      this.$route.params.id
    )
    this.$store.dispatch('tourism/initForm')
  }
}
</script>
